import React from 'react';
import { LEADERBOARD_SCOPES } from '../../utils/leaderboardPlayerScope';

const OPTIONS = [
  { id: LEADERBOARD_SCOPES.ACTIVE, label: 'Active' },
  { id: LEADERBOARD_SCOPES.ALL, label: 'All players' },
];

/**
 * Toggle between active (last 2 months) and all-player leaderboard scope.
 *
 * @param {Object} props
 * @param {'active'|'all'} props.scope
 * @param {(scope: 'active'|'all') => void} props.onScopeChange
 * @param {string} [props.className]
 */
export function LeaderboardScopeToggle({ scope, onScopeChange, className = '' }) {
  return (
    <div
      className={`inline-flex rounded-lg border border-border-medium bg-surface p-0.5 ${className}`}
      role="group"
      aria-label="Leaderboard player scope"
    >
      {OPTIONS.map((option) => {
        const isActive = scope === option.id;
        return (
          <button
            key={option.id}
            type="button"
            onClick={() => onScopeChange(option.id)}
            aria-pressed={isActive}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary min-h-[44px] sm:min-h-0 ${
              isActive
                ? 'bg-primary text-text-inverse shadow-brand-sm'
                : 'text-text-secondary hover:text-text-primary hover:bg-background'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default LeaderboardScopeToggle;
